{
  "status_submitted": "Natanggap",
  "status_in_review": "Sinusuri",
  "status_needs_info": "Kailangan ang sagot mo",
  "status_needs_info_staff": "Hinihintay ang residente",
  "status_processing": "Inaasikaso",
  "status_ready": "Handa na",
  "status_completed": "Tapos na",
  "status_rejected": "Hindi naaprubahan",
  "status_cancelled": "Kinansela",
  "kind_service": "Request sa serbisyo",
  "kind_community_report": "Problema sa komunidad",
  "kind_complaint": "Reklamo",
  "class_simple": "Simple",
  "class_complex": "Complex",
  "class_highly_technical": "Highly technical",
  "classification": "Klasipikasyon (RA 11032)",
  "classificationValue": "{name} · hanggang {count} araw ng trabaho",
  "filter_open": "Bukas",
  "filter_closed": "Sarado",
  "filter_all": "Lahat",
  "expectedBy": "Inaasahan bago {date}",
  "pastDeadline": "Lampas na sa inaasahang petsa ({date})",
  "lateDays": "{count} araw ng trabaho nang huli · takdang petsa {date}",
  "workingDaysLimit": "{count} araw ng trabaho (RA 11032)",
  "processingLimit": "Dapat kumilos ang opisina sa loob ng {count} araw ng trabaho mula nang matanggap ang kumpletong request (RA 11032).",
  "clockStopped": "Naka-pause ang takdang petsa",
  "clockStarted": "Nagsimula ang bilang",
  "closed": "Isinara",
  "ev_created": "Naipadala ang request",
  "ev_status": "Status: {status}",
  "ev_internal": "Panloob na tala",
  "ev_assigned": "Pagtatalaga",
  "ev_reply": "Mensahe mula sa residente",
  "ev_attachment": "Nagdagdag ng file",
  "ev_note": "Mensahe mula sa opisina",
  "internalOnly": "staff lang ang nakakakita nito",
  "historyTitle": "Kasaysayan",
  "filesTitle": "Mga file",
  "file": "File",
  "photo": "Larawan",
  "fromOffice": "Mula sa opisina",
  "addFile": "Magdagdag ng larawan o PDF",
  "uploading": "Ina-upload…",
  "removeFile": "Alisin ang {name}",
  "fileHint": "Mga larawan o PDF, hanggang 2 MB bawat isa pagkatapos i-compress.",
  "notEmergencyTitle": "Hindi para sa emergency",
  "notEmergencyBody": "Sunog, baha, aksidente at sinumang nasa panganib: tumawag muna sa 911.",
  "applyTitle": "Mag-apply online",
  "applyFor": "Mag-apply: {name}",
  "applyOnline": "Online na request",
  "serviceNotFound": "Hindi namin makita ang serbisyong iyon.",
  "browseServices": "Tingnan ang mga serbisyo",
  "notOnlineTitle": "Mag-apply sa opisina",
  "notOnlineBody": "Hindi pa tumatanggap ang {office} ng request na ito online. Tingnan ang mga kailangan at pumunta sa opisina sa oras ng trabaho.",
  "seeRequirements": "Tingnan ang mga kailangan",
  "officeDetails": "Oras at contact ng opisina",
  "backToService": "Bumalik sa serbisyo",
  "requirementsTitle": "Mga kailangan",
  "requirementsLead": "Mag-upload ngayon ng larawan o PDF ng bawat dokumento, o dalhin ang mga ito sa opisina. Mas maagang masusuri ng opisina kung naka-upload.",
  "whereToSecure": "Saan kukunin: {place}",
  "formTitle": "Ang iyong detalye",
  "prefilledNote": "Pinunan namin ang ilang detalye mula sa iyong profile. Suriin muna bago magpatuloy.",
  "detailsLabel": "Iba pang dapat malaman ng opisina",
  "detailsHint": "Halimbawa, may hinahabol kang petsa o may tanong ka sa opisina.",
  "continueReview": "Suriin ang aking request",
  "checkForm": "Pakisuri ang mga naka-highlight na field.",
  "consentRequired": "Sumang-ayon muna sa privacy notice para maipadala ito.",
  "reviewEyebrow": "Suriin ang request",
  "reviewLead": "Tiyaking tama ang lahat, saka ipadala.",
  "documents": "Mga dokumento",
  "documentsCount": "{count} file ang nakalakip",
  "documentsNone": "Walang na-upload — dadalhin mo sa opisina",
  "editAnswers": "Baguhin ang aking sagot",
  "afterSendNote": "Makakatanggap ka ng reference number. May {count} araw ng trabaho ang {office} para kumilos kapag kumpleto na ang request, at aabisuhan ka sa bawat hakbang.",
  "sendRequest": "Ipadala ang request",
  "sending": "Ipinapadala…",
  "sentTitle": "Naipadala ang request",
  "refLabel": "Reference number",
  "sentBody": "Natanggap ito ng {office}. Inaasahan bago {date} ({count} araw ng trabaho). Aabisuhan ka namin sa bawat galaw.",
  "trackThis": "Subaybayan ang request",
  "reportTitle": "Mag-ulat ng problema",
  "reportLead": "Baradong kanal, sirang kalsada, patay na ilaw sa kalye, hindi nakolektang basura… Sabihin sa opisinang may hawak.",
  "noTypesTitle": "Hindi pa naka-set up ang pag-uulat",
  "noTypesBody": "Hindi pa inililista ng LGU ang mga uri ng problemang tinatanggap sa app. Direktang makipag-ugnayan sa opisinang may hawak. Para sa emergency, tumawag sa 911.",
  "contactOffice": "Hanapin ang opisina",
  "whatConcern": "Anong problema?",
  "chooseType": "Piliin ang uri ng problema.",
  "routedTo": "Mapupunta sa {office} · target: {count} araw ng trabaho",
  "whereTitle": "Nasaan ito?",
  "mapLabel": "Mapa: maglagay ng pin kung saan ang problema",
  "barangayOrPin": "Piliin ang barangay o maglagay ng pin sa mapa.",
  "landmark": "Palatandaan",
  "landmarkPlaceholder": "hal. tabi ng kapilya, malapit sa gate ng paaralan",
  "whatHappened": "Ano ang nakita mo?",
  "describe": "Ilarawan ang problema",
  "describeHint": "Ano ang mali, mula kailan, at sino ang apektado.",
  "detailsRequired": "Ilarawan ang problema sa ilang salita.",
  "yourDetails": "Ang iyong contact",
  "nameRequired": "Ilagay ang iyong pangalan.",
  "mobileHint": "Maaaring mag-text o tumawag ang opisina para sa detalye.",
  "sendReport": "Ipadala ang ulat",
  "reportSentTitle": "Naipadala ang ulat",
  "reportSentBody": "Natanggap ito ng {office}. Target na petsa: {date} ({count} araw ng trabaho). Aabisuhan ka namin sa mga update.",
  "mineLead": "Lahat ng ipinadala mo sa LGU at kung nasaan na ang mga ito.",
  "applyForService": "Mag-apply sa serbisyo",
  "mineRequestsTitle": "Mga request at ulat",
  "needsReplyCount": "{count} request ang naghihintay ng sagot mo.",
  "mineEmptyOpen": "Walang inaasikaso. Lalabas dito ang mga request na ipapadala mo.",
  "mineEmpty": "Wala pa rito.",
  "mineSignedOutTitle": "Ang iyong mga request",
  "mineSignedOutBody": "Mag-sign in para mag-apply sa mga serbisyo, mag-ulat ng problema at subaybayan ang mga ito rito.",
  "registrationsLink": "Mga rehistro at ticket sa event",
  "registrationsLinkHint": "Nasa Aking aktibidad",
  "assessmentsTitle": "Mga assessment ng buwis",
  "assessment_cedula_individual": "Cedula (indibidwal)",
  "assessment_cedula_juridical": "Cedula (negosyo)",
  "assessment_rpt": "Amilyar (real property tax)",
  "assessmentStatus_unpaid": "Magbayad sa counter",
  "assessmentStatus_paid": "Bayad na",
  "assessmentStatus_cancelled": "Kinansela",
  "orNumber": "OR blg. {number}",
  "notFound": "Hindi namin makita ang request na iyon.",
  "submittedOn": "Ipinadala {date}",
  "closedOn": "Isinara {date}",
  "liveUpdates": "Live na update",
  "readyService": "Handa na. Dalhin ang reference number at isang valid ID pagkuha.",
  "readyOther": "Naaksyunan na ito ng opisina. Isasara ito sa lalong madaling panahon.",
  "askTitle": "May kailangan pa ang {office} mula sa iyo",
  "askHint": "Sumagot sa ibaba. Pagkapadala mo, magsisimula ulit ang bilang ng oras ng opisina.",
  "replyTitle": "Magmensahe sa opisina",
  "replyAskedTitle": "Ipadala ang hinihingi ng opisina",
  "replyLabel": "Mensahe",
  "replyFiles": "Mga file",
  "replyEmpty": "Magsulat ng mensahe o magdagdag ng file.",
  "resubmit": "Ibalik sa opisina",
  "sendMessage": "Ipadala ang mensahe",
  "resubmittedToast": "Naipadala. Susuriin ulit ito ng opisina.",
  "replySentToast": "Naipadala ang mensahe.",
  "whatYouSent": "Ang ipinadala mo",
  "where": "Saan",
  "pinned": "Pin sa {lat}, {lng}",
  "aboutService": "Tungkol sa serbisyong ito",
  "rateService": "Kumusta ang serbisyo? I-rate ito",
  "cancelRequest": "Kanselahin ang request",
  "cancelTitle": "Kanselahin ang request?",
  "cancelBody": "Ititigil ito ng opisina. Maaari kang magpadala ng bagong request sa ibang pagkakataon.",
  "cancelYes": "Oo, kanselahin",
  "cancelKeep": "Huwag",
  "cancelledToast": "Nakansela ang request.",
  "queueLead": "Mga aplikasyon, problema sa komunidad at reklamo para sa opisinang ito. Nauuna ang may pinakamaagang takdang petsa.",
  "exportCsv": "I-export ang CSV",
  "searchLabel": "Maghanap ng request",
  "searchPlaceholder": "Reference, pangalan o mobile number",
  "kindFilter": "Uri",
  "allKinds": "Lahat ng uri",
  "typeFilter": "Serbisyo o uri ng problema",
  "allTypes": "Lahat",
  "overdueOnly": "Lampas na",
  "assignedToMe": "Nakatalaga sa akin",
  "queueEmpty": "Walang request dito",
  "queueEmptyBody": "Subukan ang ibang filter. Lalabas dito ang bagong request sa sandaling ipadala ng residente.",
  "showing": "Ipinapakita ang {shown} sa {total}",
  "colRequest": "Request",
  "colFrom": "Mula kay",
  "colDeadline": "Takdang petsa",
  "colAssigned": "Nakatalaga kay",
  "actionsTitle": "Susunod na hakbang",
  "whatTheySent": "Ipinadala ng residente",
  "nothingElse": "Walang iba pang detalye.",
  "applicant": "Aplikante",
  "reporter": "Iniulat ni",
  "noContact": "Walang contact (binura ang account).",
  "handling": "Pag-aasikaso",
  "unassigned": "Hindi nakatalaga",
  "assignedToast": "Na-save ang pagtatalaga.",
  "action_in_review": "Simulan ang pagsusuri",
  "action_needs_info": "Humingi ng karagdagang impormasyon",
  "action_processing": "Markahang inaasikaso",
  "action_ready": "Markahang handa na",
  "action_completed": "Markahang tapos na",
  "action_rejected": "Huwag aprubahan",
  "action_submitted": "Buksan ulit",
  "action_cancelled": "Kanselahin",
  "actionHint_in_review": "Makikita ng residente na sinusuri na ito ng opisina.",
  "actionHint_needs_info": "Hihinto ang bilang hanggang sumagot ang residente. Sabihin nang malinaw kung ano ang kulang.",
  "actionHint_processing": "Kumpleto na ang request at inaasikaso.",
  "actionHint_ready": "Para sa dokumento: handa nang kunin. Sabihin sa residente kung saan at kailan.",
  "actionHint_completed": "Isasara ang request.",
  "actionHint_rejected": "Isasara ang request. Ipaliwanag kung bakit at ano ang magagawa ng residente.",
  "actionHint_submitted": "Ibabalik ang request sa listahan.",
  "actionHint_cancelled": "Isasara ang request.",
  "noteToResident": "Tala para sa residente",
  "noteToResidentHint": "Aabisuhan ang residente at makikita niya ang talang ito.",
  "noteNeedsInfo": "Sabihin sa residente kung ano ang kulang.",
  "noteRejected": "Sabihin sa residente kung bakit.",
  "statusChangedToast": "Nabago ang status: {status}.",
  "noteKind": "Uri ng tala",
  "internalNote": "Panloob na tala",
  "messageResident": "Magmensahe sa residente",
  "internalLabel": "Panloob na tala",
  "internalHint": "Staff lang ng opisinang ito ang makakakita.",
  "messageLabel": "Mensahe para sa residente",
  "messageHint": "Aabisuhan ang residente.",
  "noteEmpty": "Magsulat muna.",
  "saveNote": "I-save ang tala",
  "noteSavedToast": "Na-save ang tala.",
  "messageSentToast": "Naipadala ang mensahe sa residente.",
  "mapPinLabel": "Mapa kung nasaan ang problema",
  "dashTitle": "Mga request",
  "dashOpenQueue": "Buksan ang listahan",
  "dashOpen": "Bukas",
  "dashWaitingResident": "{count} naghihintay sa residente",
  "dashOverdue": "Lampas na",
  "dashOverdueHint": "Lampas sa limitasyon ng RA 11032",
  "dashDueWeek": "Takdang petsa ngayong linggo",
  "dashDueToday": "{count} ngayong araw",
  "dashOnTime": "Natapos sa oras",
  "dashOnTimeOf": "{onTime} sa {total} sa nakaraang 30 araw",
  "dashNoneCompleted": "Walang natapos sa nakaraang 30 araw",
  "dashMostOverdue": "Pinakamatagal nang lampas",
  "adminLead": "Ang mga uri ng problemang maiuulat ng residente, at ang opisinang pupuntahan ng bawat isa. Hangga't walang naidadagdag, sasabihin ng pahinang Mag-ulat ng problema na hindi pa ito naka-set up.",
  "adminAdd": "Magdagdag ng uri ng problema",
  "adminEdit": "Baguhin ang uri ng problema",
  "adminEmpty": "Wala pang uri ng problema",
  "adminEmptyBody": "Idagdag ang mga problemang hawak ng inyong mga opisina, halimbawa baradong kanal (Engineering) o hindi nakolektang basura (MENRO).",
  "adminName": "Pangalan",
  "adminNameHint": "Kung paano ito sasabihin ng residente, hal. \"Baradong kanal\".",
  "adminNameRequired": "Maglagay ng pangalan.",
  "adminOffice": "Opisinang may hawak",
  "adminOfficeHint": "Mapupunta sa listahan ng opisinang ito ang ganitong ulat.",
  "adminOfficeRequired": "Piliin ang opisina.",
  "adminChooseOffice": "Pumili ng opisina",
  "adminMunicipal": "Mga opisina ng munisipyo",
  "adminBarangays": "Mga barangay",
  "adminClassHint": "Ang target na oras ng pagtugon na ipinapakita sa residente at ginagamit sa abiso ng lampas na.",
  "adminIcon": "Icon",
  "adminActive": "Mapipili ito ng residente",
  "adminActiveHint": "I-off para itigil ang bagong ulat ng ganitong uri; mananatili ang mga dati.",
  "adminInactive": "Nakatago",
  "adminSaved": "Na-save ang uri ng problema.",
  "adminMoveUp": "Itaas ang {name}",
  "adminMoveDown": "Ibaba ang {name}",
  "holidaysLead": "Araw ng trabaho ang binibilang sa takdang petsa ng RA 11032. Laging hindi kasama ang Sabado at Linggo; ilista rito ang mga regular at special non-working day, pati lokal na holiday gaya ng pista ng bayan.",
  "holidayAddTitle": "Magdagdag ng araw na walang pasok",
  "holidayName": "Pangalan",
  "holidayNamePlaceholder": "hal. Undas (All Saints' Day)",
  "holidayAdd": "Idagdag",
  "holidayAdded": "Naidagdag ang holiday.",
  "holidayDateRequired": "Piliin ang petsa.",
  "holidayNameRequired": "Ilagay ang pangalan.",
  "holidaysIn": "Mga araw na walang pasok sa {year}",
  "year": "Taon",
  "holidaysEmpty": "Walang nakalistang holiday sa {year}",
  "holidaysEmptyBody": "Sabado at Linggo lang ang nilalaktawan hangga't walang naidadagdag na holiday.",
  "holidayRemove": "Alisin ang {name}",
  "holidayRemoved": "Naalis ang {name}.",
  "lateDays_one": "1 araw ng trabaho nang huli · takdang petsa {date}",
  "documentsCount_one": "1 file ang nakalakip",
  "needsReplyCount_one": "1 request ang naghihintay ng sagot mo."
}
